import { RestSlice } from '../../../../../redux/rest.slice';
import { Lookup } from '@rcp/types';
import { localizationService, Resource } from 'src/services';

export const settingLookupsSiteUseSlice = new RestSlice<Lookup>(
	localizationService.getLocalizedString('cccSettings.lookupSiteUses'),
	Resource.SettingLookup + '/SiteUses'
);
export default settingLookupsSiteUseSlice.rests.reducer;
